module.exports = __webpack_public_path__ + "img/medium-square.fd228f16.svg";